export default function ResponsiveText({
  longText,
  shortText,
}: {
  longText: string;
  shortText: string;
}) {
  return (
    <div>
      <div className="max-sm:hidden">{longText}</div>
      <div className="sm:hidden">{shortText}</div>
    </div>
  );
}
